{
  "monitors": {
    "events": {
      "analysisFailed": "The sources could not be analysed during this check. A retry is scheduled for the next cycle."
    }
  },
  "dateFormats": {
    "hoursMinutes": "HH:mm",
    "inFullDateFormat": "ddd, DD MMMM YYYY - HH:mm",
    "longDate": "DD MMMM YYYY",
    "longDateTime": "DD MMMM YYYY HH:mm",
    "longDateWithDay": "dddd DD MMMM YYYY",
    "numericDate": "dd/MM/yyyy",
    "shortDate": "DD/MM/YYYY",
    "shortDateWithMonthAndYear": "D/M/YYYY",
    "shortDateWithMonthDateFns": "d MMM",
    "shortDayMonthNumeric": "DD/MM",
    "weekdayDateTimeAmPm": "ddd D MMM YYYY · h:mm A"
  },
  "featureDemo": {
    "flows": {
      "sidePanel": {
        "steps": [
          "Summarise",
          "Add label",
          "Archive",
          "AI ask",
          "Send Slack",
          "Create task"
        ]
      }
    }
  },
  "flowEditor": {
    "steps": {
      "SUMMARIZE": "Summarise"
    }
  },
  "flows": {
    "approvalGate": {
      "summaryPromptPlaceholder": "e.g. Summarise what needs approval: {{step1.subject}}"
    }
  },
  "mcpConnections": {
    "oauthClientModal": {
      "authorizeButton": "Authorise"
    }
  },
  "doBox": {
    "taskGroupSelector": {
      "createSubtitle": "Pick a colour for your list"
    }
  },
  "integration": {
    "manageAccountsModal": {
      "addAnotherGitHubOrgButton": "Add another GitHub organisation"
    },
    "catalog": {
      "requestFooter": {
        "subtitlePersonal": "Our catalogue is growing. Request one and help prioritise.",
        "subtitleTeam": "Request one and our team will review it for the shared catalogue."
      }
    }
  },
  "floatingAssistant": {
    "panel": {
      "minimize": "Minimise"
    },
    "suggestions": {
      "summarizePendingTasks": "Summarise my pending tasks",
      "summarizeActiveFlows": "Summarise my active flows"
    }
  },
  "brain": {
    "sidebar": {
      "pageActions": {
        "favorite": "Add to favourites",
        "unfavorite": "Remove from favourites"
      }
    },
    "favorites": {
      "errorGeneric": "Couldn't update favourites. Please try again.",
      "limitReached": "You've reached the limit of {{limit}} favourites."
    }
  },
  "discover": {
    "generator": {
      "inputPlaceholder": "e.g. Summarise our Slack channels into a daily digest…",
      "examples": {
        "slackDigest": "Summarise Slack channels into a daily digest"
      }
    },
    "agents": {
      "knowledgeCurator": {
        "description": "Turns raw notes and threads into organised Brain pages and keeps your knowledge space tidy."
      }
    }
  },
  "teamHub": {
    "modal": {
      "editSubtitle": "Update your team's name and icon colour.",
      "colorLabel": "Icon colour"
    }
  },
  "components": {
    "createBoardList": {
      "pickListColor": "Pick a colour for your list"
    }
  }
}
